import type { ReactNode } from "react"

import { cn } from "../lib/cn"

export type TomDaBarra = "critico" | "atencao" | "informacao"

export type ItemDeBarra = {
  chave: string
  rotulo: string
  valor: number
  texto?: string
  nota?: string
  tom?: TomDaBarra
  selo?: ReactNode
}

const COR_DA_BARRA: Record<TomDaBarra, string> = {
  critico: "bg-status-erro",
  atencao: "bg-status-atencao",
  informacao: "bg-(--barra-do-grafico)",
}

export function BarrasHorizontais({ itens, emDuasColunas = false }: { itens: ItemDeBarra[]; emDuasColunas?: boolean }) {
  const maior = Math.max(0, ...itens.map((item) => item.valor))
  return (
    <ul className={cn("grid grid-cols-1 gap-4", emDuasColunas && "gap-x-10 md:grid-cols-2")}>
      {itens.map((item) => (
        <li key={item.chave} data-chave={item.chave} className="flex flex-col gap-1.5 text-sm">
          <span className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1">
            <span className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
              <span className="min-w-0 font-medium first-letter:uppercase">{item.rotulo}</span>
              {item.selo}
            </span>
            <span className="ml-auto flex items-baseline gap-1.5 text-right whitespace-nowrap tabular-nums">
              <span className="font-semibold">{item.texto ?? item.valor.toLocaleString("pt-BR")}</span>
              {item.nota !== undefined && (
                <>
                  <span aria-hidden="true" className="text-border">|</span>
                  <span className="font-semibold text-muted-foreground">{item.nota}</span>
                </>
              )}
            </span>
          </span>
          <span aria-hidden="true" className="ml-2 h-3 overflow-hidden rounded-full bg-muted">
            {maior > 0 && item.valor > 0 && (
              <span
                data-slot="barra"
                className={cn("block h-full min-w-1 rounded-full", COR_DA_BARRA[item.tom ?? "informacao"])}
                style={{ width: `${(item.valor / maior) * 100}%` }}
              />
            )}
          </span>
        </li>
      ))}
    </ul>
  )
}
